"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _metrics = require("../common/metrics");
var _form = _interopRequireDefault(require("./form"));
var APIIcon = function APIIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#939393",
    d: "M11.533 2.521a.937.937 0 0 1 .938 0l7.506 4.334c.29.167.469.477.469.812v8.667a.938.938 0 0 1-.47.812l-1.065.616a.469.469 0 0 1-.703-.407V8.633a.375.375 0 0 0-.187-.324L12.19 4.942a.375.375 0 0 0-.375 0L5.983 8.309a.375.375 0 0 0-.187.324v8.723c0 .36-.39.586-.703.405l-1.066-.615a.938.938 0 0 1-.469-.812V7.667c0-.335.179-.645.469-.812l7.506-4.334z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#5C5C5C",
    d: "M11.156 13.593a.281.281 0 0 1-.281-.28v-1.951c0-.134.072-.258.188-.325l.743-.43a.375.375 0 0 1 .375 0l.757.438c.115.066.187.19.187.324v1.943a.281.281 0 0 1-.281.281h-1.688z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#2E2E2E",
    d: "M13.125 20.887v-4.764a.281.281 0 0 0-.28-.282l-1.687-.01a.281.281 0 0 0-.283.28v4.77c0 .133.072.257.188.324l.756.437a.375.375 0 0 0 .375 0l.743-.43a.375.375 0 0 0 .188-.325z"
  }));
};
APIIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
var config = {
  angConfiguration: {
    typeURL: 'http://anypoint.com/vocabs/digital-repository#WebAPISpecFragmentAsset',
    assetType: 'WebAPISpecFragment'
  },
  owner: {
    gusTeam: 'TBD'
  },
  name: 'API Spec Fragment',
  publication: {
    uiForm: _form.default,
    inferredBy: [{
      classifiers: ['raml-fragment', 'json-schema', 'oas-components']
    }],
    files: [{
      id: 'raml-fragment',
      classifier: 'raml-fragment',
      packaging: 'zip',
      mainFileLocationProperty: 'mainFile',
      amfContentTypeHeader: 'application/raml',
      usedAsDependency: true
    }, {
      id: 'single-file-raml-fragment',
      classifier: 'raml-fragment',
      packaging: 'raml',
      mainFileLocationProperty: 'mainFile',
      amfContentTypeHeader: 'application/raml'
    }, {
      id: 'json-schema',
      classifier: 'json-schema',
      packaging: 'zip',
      mainFileLocationProperty: 'mainFile',
      amfContentTypeHeader: 'application/schema+json',
      usedAsDependency: true
    }, {
      id: 'single-file-json-schema',
      classifier: 'json-schema',
      packaging: 'json',
      mainFileLocationProperty: 'mainFile',
      amfContentTypeHeader: 'application/schema+json'
    }, {
      id: 'oas-components',
      classifier: 'oas-components',
      packaging: 'zip',
      mainFileLocationProperty: 'mainFile',
      amfContentTypeHeader: 'application/oas-components',
      usedAsDependency: true
    }, {
      id: 'single-file-oas-components-yaml',
      classifier: 'oas-components',
      packaging: 'yaml',
      mainFileLocationProperty: 'mainFile',
      amfContentTypeHeader: 'application/oas-components'
    }, {
      id: 'single-file-oas-components-json',
      classifier: 'oas-components',
      packaging: 'json',
      mainFileLocationProperty: 'mainFile',
      amfContentTypeHeader: 'application/oas-components'
    }],
    minimumInputSets: [{
      files: ['raml-fragment'],
      requiredProperties: ['mainFile']
    }, {
      files: ['single-file-raml-fragment'],
      requiredProperties: ['mainFile']
    }, {
      files: ['json-schema'],
      requiredProperties: ['mainFile']
    }, {
      files: ['single-file-json-schema'],
      requiredProperties: ['mainFile']
    }, {
      files: ['oas-components'],
      requiredProperties: ['mainFile']
    }, {
      files: ['single-file-oas-components-yaml'],
      requiredProperties: ['mainFile']
    }, {
      files: ['single-file-oas-components-json'],
      requiredProperties: ['mainFile']
    }],
    customProperties: [{
      name: 'projectId',
      storeAsAttribute: true
    }, {
      name: 'branchId',
      storeAsAttribute: true
    }, {
      name: 'commitId',
      storeAsAttribute: true
    }, {
      name: 'originalFormatVersion',
      storeAsAttribute: true
    }, {
      name: 'fragmentFormat',
      storeAsAttribute: true
    }],
    // Deactivating no-package-generator check for this historical Asset Type
    // eslint-disable-next-line asset-definitions/no-package-generator
    ootbSteps: [{
      name: 'packageGenerator'
    }, {
      name: 'amfValidation',
      allowedFileIds: ['raml-fragment', 'single-file-raml-fragment', 'json-schema', 'single-file-json-schema', 'oas-components', 'single-file-oas-components-yaml', 'single-file-oas-components-json']
    }],
    extensionPoints: [{
      name: 'legacyMetadataExtraction',
      timeout: 120
    }, {
      name: 'validation',
      timeout: 120
    }, {
      name: 'postOperation',
      timeout: 30
    }]
  },
  portal: {
    icon: APIIcon,
    color: '#abe2f5' // coreBlue1
  },
  keywords: ['raml', 'fragment'],
  metrics: {
    visualization: {
      columns: [_metrics.ASSET_DOWNLOAD, _metrics.IMPORTS_FROM_APID, _metrics.IMPORTS_FROM_STUDIO, _metrics.ASSET_DEPENDENT, _metrics.ASSET_CONTRACT]
    }
  }
};
var _default = exports.default = config;
//# sourceMappingURL=config.js.map